<template>
    <div> 
        <multiselect class="form-control" v-model="modelo.iddepartamento" :options="datos" track-by="id" label="label" 
        :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Seleccione..." :allow-empty="true"></multiselect>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{ 
        model:Object,
        default:{type:Object,required:false,default:null},
        showext:{Boolean, default: false},
        panama:{Boolean, default: false}
    },
    data(){
        return{
            datos: [],
            seteado: null,
            modelo: {
                iddepartamento: null,
            }
        }
    },
    watch:{
        'modelo.iddepartamento': function(){this.model.iddepartamento=this.modelo.iddepartamento; },
        'default':function(a){
            if( a == null ) return;
            this.modelo.iddepartamento = a;
            this.setdefault();
        },
    },
    methods:{
        setdefault(){
            if(this.default){
                const select = this.datos.find(x=>x.id==this.default.id);
                this.modelo.iddepartamento = select;
            }
        },
        setID(id){
            const select = this.datos.find(x=>x.id==id);
            this.modelo.iddepartamento = select;
        },
        async getDatos(idpais=null) {
            this.datos = [];
            if(!idpais) this.cargarDatos1();
            else this.cargarDatos2(idpais);
        },
        async cargarDatos1(){
            var vue = this;
            var sql = gql`query{getDepartamentos{id,nombre,extension}}`;
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                let depas = data.data.getDepartamentos;
                if(!this.panama){
                    depas = depas.filter(x=>x.id <= 10)
                }else{
                    depas = depas.filter(x=>x.id > 10)
                }
                if(this.showext){
                    depas.forEach(d => d.label = `${d.extension} - ${d.nombre}` );
                }else{
                    depas.forEach(d => d.label = `${d.nombre}` );
                }
                vue.datos = depas;
                this.ponerDefecto();
                this.setdefault();
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getDepartamentos' ) )
            })
        },
        async cargarDatos2(idpais){
            let myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");
            let sqlp = `query{ departamentosByPaisID(idpais:${idpais}){ id nombre extension idpais} }`;
            let graaa = JSON.stringify({ query: sqlp, variables: {} });
            let reqq = { method: "POST", headers: myHeaders, body: graaa };
            const r = await fetch(process.env.VUE_APP_API_PUBLIC, reqq).then((response) => response.json());
            if(r && r.data){ 
                let depas = r.data.departamentosByPaisID;
                depas.forEach(d => d.label = `${d.nombre}` ); 
                this.datos = depas;
                this.ponerDefecto();
            }
        },
        ponerDefecto(){
            for(let i=0;i<this.datos.length;i++){
                let x = this.datos[i];
                let nombre = x.nombre.toLowerCase();
                
                if(nombre.includes(this.seteado)){
                    // window.console.log('-->',nombre, this.seteado);
                    this.modelo.iddepartamento = x;
                }
            }
        },

        // externo
        findCi(exp) {
            this.seteado = exp.toLowerCase();
            this.ponerDefecto();
            // window.console.log('--->', this.datos, exp);
        }
    },
    mounted(){
        this.getDatos();
    }
}
</script>